import { MonitoringActivity } from '@/types/apiModels'
import { queryKeys } from '../../../../hooks/data/queryKeys'
import { queryClient } from '../../../../queryClient'
import { type ApiV2QueryType } from '../../../ruutsApi/types'
import getMonitoringActivities from './getMonitoringActivities'

// Imperative, cache-aware activity lookup used from an event callback (SOC dialog columns),
// not at render time — hence queryClient.fetchQuery rather than a useQuery hook (playbook §2.5).
export const loadMonitoringActivities = (
  query: ApiV2QueryType<MonitoringActivity> & { farmId: string },
) =>
  queryClient.fetchQuery({
    queryKey: queryKeys.monitoringActivities(query),
    queryFn: ({ signal }) => getMonitoringActivities({ query, signal }),
  })
